<div class="mt-4 flex justify-content-center gap-4 flex-wrap">
	<div *ngFor="let item of catalogues" class="catalogue-card flex flex-column justify-content-center align-items-center gap-2 cursor-pointer" (click)="openFlipbook(item)">
		<div class="catalogue-thumb flex align-items-center justify-content-center">
			<img src="{{item.url}}?width=300" alt="{{item.name_catalogue}}" />
		</div>
		<span class="text-xl text-center">{{item.name_catalogue}}</span>
	</div>

</div>

<p-dialog [(visible)]="showDialog" [modal]="true" [maximizable]="false" styleClass="flipbook-dialog" [style]="{width: '100vw', height: '100vh', 'max-height': '100vh'}" [contentStyle]="{height: 'calc(100% - 36px)', overflow: 'hidden', display: 'flex', 'flex-direction': 'column', padding: '0'}" (onHide)="closeFlipbook()" [header]="selectedCatalogue?.name_catalogue || 'Catalogue'">
	<ng-template pTemplate="header">
		<span class="text-lg font-bold">{{selectedCatalogue?.name_catalogue || 'Catalogue'}}</span>
		<a *ngIf="selectedCatalogue" [href]="selectedCatalogue.url" target="_blank" download class="p-button p-button-text p-button-sm ml-3" style="padding:4px 8px">
			<i class="pi pi-download mr-1"></i> Télécharger
		</a>
	</ng-template>
	<app-flipbook *ngIf="selectedCatalogue" [pdfUrl]="selectedCatalogue.url" [name]="" style="flex:1;overflow:hidden"></app-flipbook>
</p-dialog>